<template>
  <div class="page payment-page">
    <!-- 头部导航 -->
    <header class="header">
      <div class="nav-left">
        <div class="back-btn el-icon-arrow-left" @click="goBack"></div>
      </div>
      <div class="nav-center">
        <h1 class="page-title">支付记录</h1>
      </div>
    </header>

    <div class="list">
      <div class="card" v-for="item in records" :key="item.id">
        <div class="info">
          <div class="name">{{ item.name }}</div>
          <div class="time-info">
            <div class="time">购买数量：{{ item.purchaseQuantity }}</div>
            <div class="time">支付时间：{{ item.paymentTime }}</div>
          </div>
          <div class="payment-info">
            <div class="amount">支付金额：¥{{ item.amount }}</div>
          </div>
        </div>
      </div>

      <!-- 加载状态 -->
      <div class="loading-container" v-if="loading&&total>records.length">
        <div class="loading-spinner"></div>
        <div class="loading-text">加载中...</div>
      </div>

      <!-- 没有更多数据提示 -->
      <div class="no-more-data" v-if="total==records.length">
        <div class="no-more-text">没有更多支付记录了</div>
      </div>

      <!-- 空状态 -->
      <div class="empty-state" v-if="!loading && records.length === 0">
        <div class="empty-icon el-icon-money"></div>
        <div class="empty-text">暂无支付记录</div>
      </div>
    </div>

    <!-- 页面加载组件 -->
    <div v-if="isLoading" class="page-loading-overlay">
      <div class="page-loading-container">
        <!-- 旋转的圆圈动画 -->
        <div class="page-spinner">
          <div class="page-spinner-inner"></div>
        </div>

        <!-- 加载文字 -->
        <div class="page-loading-text">
          <span class="page-loading-dots">
            <span class="page-dot">.</span>
            <span class="page-dot">.</span>
            <span class="page-dot">.</span>
          </span>
        </div>

        <!-- 可选的加载提示文字 -->
        <div v-if="loadingText" class="page-loading-message">{{ loadingText }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/utils/api";
export default {
  name: "PaymentRecords",
  data() {
    return {
      records: [],
      // 页面加载状态
      isLoading: false,
      loadingText: "加载中，请稍等",
      // 分页相关状态
      currentPage: 1,
      pageSize: 10,
      loading: false,
      TotalPages:0,
      total: 0
    };
  },
  async mounted() {
    // 添加滚动监听
    window.addEventListener("scroll", this.handleScroll);
    this.isLoading = true;
    try {
      await Promise.all([this.getPaymentRecords()]);
    } catch (error) {
      this.$message.error("接口请求出错");
    } finally {
      this.isLoading = false;
    }
  },
  beforeDestroy() {
    // 移除滚动监听
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    // 处理滚动事件
    handleScroll() {
      // 检查是否滚动到底部
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      // 当滚动到距离底部100px时触发加载
      if (scrollTop + windowHeight >= documentHeight - 100) {
        this.loadMore();
      }
    },
    // 加载更多数据
    async loadMore() {
      if (this.total > this.records.length&&this.currentPage<this.TotalPages) {
        this.currentPage++;
        await this.getPaymentRecords();
      }
    },
    async getPaymentRecords() {
      this.loading = true;
      try {
        const response = await api.PaymentRecords(
          this.currentPage,
          this.pageSize
        );
        if (response && response.data.length > 0) {
          this.total = response.TotalCount;
          this.TotalPages = response.TotalPages;
          const paymentRecords = [
            ...response.data.map(item => {
              return {
                name: item.ShouKuanXiang,
                purchaseQuantity: item.ShuLiang,
                paymentTime: item.ShouKuanShiJian,
                amount: item.ShouKuanZongJinE,
              };
            })
          ];
          this.records = [...this.records, ...paymentRecords];
        }
      } catch (error) {
        console.error("获取支付记录失败:", error);
        this.$message && this.$message.error("获取支付记录失败");
        this.records = [];
      } finally {
        this.loading = false;
      }
    },
  }
};
</script>

<style scoped>
.payment-page {
  min-height: 100vh;
  background: #f7f7f7;
}
/* 头部导航 */
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: white;
  border-bottom: 1px solid #e0e0e0;
}

.nav-left,
.nav-right {
  width: 40px;
  z-index: 99;
}

.nav-center {
  flex: 1;
  text-align: center;
}

.page-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0 0 0 -40px;
}

.back-btn,
.share-btn {
  background: none;
  border: none;
  font-size: 18px;
  color: #333;
  cursor: pointer;
  padding: 8px;
}

.title {
  font-size: 16px;
  font-weight: 600;
}

.list {
  padding: 12px 12px 24px;
}

.card {
  display: flex;
  background: #fff;
  border-radius: 10px;
  padding: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  margin-bottom: 12px;
  align-items: center;
}

.poster {
  width: 90px;
  object-fit: contain;
  border-radius: 8px;
  margin-right: 12px;
}

.info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.name {
  font-size: 16px;
  color: #111;
  font-weight: 600;
}

.time-info {
  margin-top: 6px;
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.time {
  font-size: 12px;
  color: #666;
}

.payment-info {
  margin-top: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.amount {
  font-size: 14px;
  color: #e74c3c;
  font-weight: 600;
}

.status {
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 12px;
  font-weight: 500;
}

.status-pending {
  background: #fff3cd;
  color: #856404;
}

.status-success {
  background: #d4edda;
  color: #155724;
}

.status-failed {
  background: #f8d7da;
  color: #721c24;
}

.status-refunded {
  background: #d1ecf1;
  color: #0c5460;
}

.status-unknown {
  background: #e2e3e5;
  color: #383d41;
}

/* 加载状态样式 */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  color: #666;
}

.loading-spinner {
  width: 24px;
  height: 24px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 8px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading-text {
  font-size: 14px;
  color: #999;
}

/* 没有更多数据样式 */
.no-more-data {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.no-more-text {
  font-size: 14px;
  color: #999;
  position: relative;
}

.no-more-text::before,
.no-more-text::after {
  content: "";
  position: absolute;
  top: 50%;
  width: 40px;
  height: 1px;
  background-color: #e0e0e0;
}

.no-more-text::before {
  left: -50px;
}

.no-more-text::after {
  right: -50px;
}

/* 空状态样式 */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #999;
}

.empty-icon {
  font-size: 48px;
  margin-bottom: 16px;
  opacity: 0.6;
}

.empty-text {
  font-size: 16px;
  color: #666;
}
/* 页面加载组件样式 */
.page-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

.page-loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  padding: 40px 30px;
  min-width: 200px;
  text-align: center;
}

/* 旋转动画 */
.page-spinner {
  width: 50px;
  height: 50px;
  position: relative;
  margin-bottom: 20px;
}

.page-spinner-inner {
  width: 100%;
  height: 100%;
  border-top: 4px solid #fff;
  border-radius: 50%;
  animation: pageSpin 1s linear infinite;
}

@keyframes pageSpin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* 加载文字样式 */
.page-loading-text {
  font-size: 16px;
  color: #fff;
  font-weight: 500;
  margin-bottom: 10px;
}

.page-loading-dots {
  display: inline-block;
}

.page-dot {
  animation: pageDotPulse 1.4s infinite ease-in-out;
  animation-fill-mode: both;
}

.page-dot:nth-child(1) {
  animation-delay: -0.32s;
}

.page-dot:nth-child(2) {
  animation-delay: -0.16s;
}

.page-dot:nth-child(3) {
  animation-delay: 0s;
}

@keyframes pageDotPulse {
  0%,
  80%,
  100% {
    opacity: 0.3;
    transform: scale(0.8);
  }
  40% {
    opacity: 1;
    transform: scale(1);
  }
}

/* 加载提示文字 */
.page-loading-message {
  font-size: 14px;
  color: #fff;
  margin-top: 8px;
  max-width: 200px;
  line-height: 1.4;
}
@media (max-width: 768px) {
  .poster {
    width: 72px;
  }

  .loading-container {
    padding: 16px;
  }

  .loading-spinner {
    width: 20px;
    height: 20px;
  }

  .loading-text {
    font-size: 13px;
  }

  .no-more-data {
    padding: 16px;
  }

  .no-more-text {
    font-size: 13px;
  }

  .no-more-text::before,
  .no-more-text::after {
    width: 30px;
  }

  .no-more-text::before {
    left: -40px;
  }

  .no-more-text::after {
    right: -40px;
  }

  .empty-state {
    padding: 40px 20px;
  }

  .empty-icon {
    font-size: 40px;
    margin-bottom: 12px;
  }

  .empty-text {
    font-size: 14px;
  }
}
</style>
